import { render } from "./MfExcelImport.vue?vue&type=template&id=6080136e&scoped=true"
import script from "./MfExcelImport.vue?vue&type=script&lang=js"
export * from "./MfExcelImport.vue?vue&type=script&lang=js"

import "./MfExcelImport.vue?vue&type=style&index=0&id=6080136e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6080136e"]])

export default __exports__